
import React, { useState,useEffect } from "react";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from 'react-redux';
import { Link, NavLink, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-awesome-modal';
import { PhoneInput } from "react-contact-number-input";
import { SvgElement, icontypesEnum } from "../assets/svgElement";
import { AdminApis } from "../../apis/adminApi";
import { FaTrash, FaEdit } from "react-icons/fa";
import { AiOutlineWarning } from "react-icons/ai";
import EmojiPicker from 'emoji-picker-react';
import { useParams } from 'react-router-dom';
import { MutatingDots } from 'react-loader-spinner'
import { ThreeDots } from 'react-loader-spinner'
import { TailSpin } from 'react-loader-spinner'
import { Oval } from 'react-loader-spinner'
import { Swiper, SwiperSlide } from "swiper/react";
import { FaWhatsapp, FaEye } from "react-icons/fa";
import configs from "../../configs";



// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Navigation } from "swiper";
import { PaymentApis } from "../../apis/paymentApis";
import Navbar from "../Navbars/Navbar";
import { CartApis } from "../../apis/cartApis";
import Footer from "../Footers/Footer";

// components



export default function CardEditProduct() {
  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const userLoginData = useSelector((state) => state.data.login.value);
  const [pro1, setPro1] = React.useState([]);
  const [pro2, setPro2] = React.useState([]);
  const [pro3, setPro3] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [otherData, setOtherData] = React.useState([]);
  const delay = 2500;

  const routeLocation = useLocation();

  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === colors.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);
  let [marketInfo, setMarketInfo] = React.useState('');


  let [latestparam, setLatestparam] = React.useState(params?.id);




  if (params?.id !== latestparam) {
    window.location.reload();
  }

  React.useEffect(() => {
    setLatestparam(params?.id)
    AdminApis.getSingleProductOutside(params?.id).then(
      (response) => {
        if (response?.data) {
          setPro1(response?.data?.data?.product?.product_image_1)
          setPro2(response?.data?.data?.product?.product_image_2)
          setPro3(response?.data?.data?.product?.product_image_3)
          // setData(response?.data?.data)
          setData(response?.data?.data?.product)
          // console.log(response?.data?.data)
          setOtherData(response?.data?.data?.similar_products)
          // console.log(response?.data?.data?.similar_products)
          setMarketInfo(response?.data?.data?.market_info)
        }
      }
    );

  }, []);
  // setData(otherData)


  let colors = [pro1, pro2, pro3];
// console.log(pro2)
  let [visible, setVisible] = React.useState(false);
  let [value, setvalue] = React.useState('');
  let [fullName, setFullName] = React.useState('');
  let [email, setEmail] = React.useState('');
  let [phoneNumber, setPhoneNumber] = React.useState('');
  let [productQty, setProductQty] = React.useState('');


  function togglePaymentModal(value2) {
    setvalue(value2)
    setVisible(true)
  }

  const addToCart = React.useCallback(
    (productInfo) => {

      if (!userLoginData?.id) {
        navigate('/sign-in');
      }

      // {userLoginData?.id?

      // }
      let datas = {
        'product_id': productInfo?.id,
        'product_price': (routeLocation?.state && productInfo?.is_under_deal
          ? ((productInfo?.discounted_price) - ((productInfo?.discounted_price) * (routeLocation?.state / 100))) 
          : routeLocation?.state && !productInfo?.is_under_deal ? ((productInfo?.product_price) - ((productInfo?.product_price) * (routeLocation?.state / 100))) 
        : productInfo?.is_under_deal ? (productInfo?.discounted_price) : (productInfo?.product_price)),
        'quantity': 1,
        'product_name': productInfo?.product_name,
        'product_img': productInfo?.product_image_1 ? productInfo?.product_image_1 : 'no image',
        'user_id': userLoginData?.id,
      }
      // console.log(datas)
      // console.log(productInfo)
      CartApis.createCart(datas).then(
        (response) => {
          if (response?.data) {
            // console.log(response?.data)

            // window.location.replace(response?.data?.data?.data?.link);
            // setVisible(false)
            toast.success(response?.data?.message);
            window.location.reload();
          }
        // window.location.reload();

        }

      ).catch(function (error) {
        // handle error
        console.log(error.response.data);
        toast.error("Offfline");
      }).finally(() => {
        // toast.success("success");
        //  console.log('response?.data')
        //     window.location.reload();
            
        

      });
    },
    [value, fullName, email, phoneNumber, params, productQty]
  );





  return (
    <>

      <Navbar />
      <div className="grid lg:grid-cols-[3.20fr_1.5fr] mx-5">

        <div className="flex flex-col s-[0.20fr_3fr] ">
<div className="flex lg:flex-row flex-col"> 

      <div className="flex  lg:flex-col mt-10 lg:space-y-5">
        <div className="border rounded-lg w-32 h-32 p-2 ">
      <img  src={pro1}  alt={pro1}/>
        </div>
        <div className="border rounded-lg w-32 h-32 p-2">
        <img  src={pro1}  alt={pro2}/>
        </div>
        <div className="border rounded-lg w-32 h-32 p-2">
        <img  src={pro1}  alt={pro3}/>
        </div>
        <div className="border rounded-lg w-32 h-32 p-2">
        <img  src={pro1}  alt={pro1}/>
        </div>
      </div>
      
        <div className=" md :basis- 7/12 pt-10">

          <div className="border rounded-lg p-4 md:p-10 md:ml-10 md:mr-10 md:mb-10 ">
            <Swiper
              navigation={true}
              modules={[Navigation]}
              pagination={true}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              className="mySwiper"
            // style={{maxHeight:'400px'}}
            >

              {pro1 ?
                <SwiperSlide>
                  <img className="object-fill w-full h-[500px] md:min-h-[500px] min-h-[300px] max-h-[300px] md:max-h-[500px]" src={pro1} alt={pro1} />
                </SwiperSlide>
                :
                ''
              }

              {pro2 && pro2 !== "null" && pro2 !== null ?
                <SwiperSlide>
                  <img className="object-fill w-full h-[500px] md:min-h-[500px] min-h-[300px] max-h-[300px] md:max-h-[500px]" src={pro2} alt={pro2} />
                </SwiperSlide>
                :
                ''
              }



              {pro3 && pro3 !== "null" && pro3 !== null ?
                <SwiperSlide>
                  <img className="object-fill w-full h-[500px] md:min-h-[500px] min-h-[300px] max-h-[300px] md:max-h-[500px]" src={pro3} alt={pro3} />
                </SwiperSlide>
                :
                ''
              }

            </Swiper>
          </div>

      
        </div>
        </div>

        <div className="flex flex-col mr-5">


        <div className="w-full">
        <span className="mt-10 font-[500]">About the Item</span>
              <div className="  w-full border-[2px] justify-center rounded-lg px-4 py-3 ">
                <p className="py-3 ">Product Details</p>

                <span className=" text-[12px] font-[400]">{data?.product_description !== "null" && data?.product_description}</span>
              </div>
        </div>


          </div>


      </div>

        <div className=" md:basis-5/12 mt-10">
          <div className=" border-[2px] rounded-lg px-4 py-3 border-[#E3E4E5]">
            <div className="flex flex-col">
              <span className="text-[26px] font-[800] mt-1">{data?.product_name}</span>

              {routeLocation?.state ?
                <span className="flex flex-col mt-8">
                  {data?.is_under_deal ? (
         <div className='flex flex-col'>
          <div className="flex gap-2">
         <span className="line-through mr-2 text-[red] text-[16px]">
         {(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((data?.original_price) ? (data?.original_price) : 0.0))}
</span>
<h3 className='text-[16px] font-semibold'>NGN{(data?.discounted_price)}</h3>
        </div>
        <span className="text-[#2E2F32] text-[20px] font-[700] ">{(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((data?.discounted_price) ? ((data?.discounted_price) - ((data?.discounted_price) * (routeLocation?.state / 100))) : 0.0))}</span>

        </div>
                  ) : (
                    <div className="flex flex-col">
   <span className="text-[red] text-[16px] line-through font-[700] ">{(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((data?.product_price) ? (data?.product_price) : 0.0))}</span>
                  <span className="text-[#2E2F32] text-[20px] font-[700] ">{(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((data?.product_price) ? ((data?.product_price) - ((data?.product_price) * (routeLocation?.state / 100))) : 0.0))}</span>
              
                    </div>
                  )}
                 </span>
                :
                
              <div className="mt-8">
{data?.is_under_deal ? (
<div className=" flex gap-2 items-center ">
<span className="line-through text-[20px] text-gray-500">
        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(data?.original_price)}
      </span>
      <h3 className='text-[#2E2F32] text-[20px] font-[700]'>NGN{(data?.discounted_price)}</h3>

  </div>
) : (
  <div>
<span className="text-[#2E2F32] text-[20px] font-[700] mt-8">{(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((data?.product_price) ? (data?.product_price) : 0.0))}</span>

    </div>
)}
</div>
              }


              {/* <span className="text-[#2E2F32] text-[16px] font-[700] mt-3">Size: {data?.link_name == 'null' ? '--' : data?.link_name}</span> */}
              {/* <span className="text-[#2E2F32] text-[16px] font-[700] mt-3">Number Of Items In Store: {data?.no_of_items == '--' ? '--' : data?.no_of_items}</span> */}

              {
                (data?.no_of_items == '--' || data?.no_of_items == 0) ?
                  <button
                    type="button"
                    disabled

                    className=" mt-10 w-full text-white focus:ring-4  bg-gray-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Out of Stock
                  </button>

                  :
                  <button
                    type="button"
                    onClick={() => addToCart(data)}
                    style={{ backgroundColor: '#0071BC', borderRadius: '50px' }}
                    className=" mt-10 w-full text-white hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Add to cart
                  </button>
              }
{/* 
              <div className="flex flex-col gap-2 mt-5 bg-blue-50 rounded-xl px-4">
                <div className="flex flex-row gap-2 mt-5">
                  <div> <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" transform="translate(0.329956 0.5)" fill="url(#pattern0_34_2350)" />
                        <defs>
                          <pattern id="pattern0_34_2350" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref="#image0_34_2350" transform="scale(0.01)" />
                          </pattern>
                          <image id="image0_34_2350" width="100" height="100" xlinkHref="data:image/png;base64,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" />
                        </defs>
                      </svg></div>
                      <div>
                        <h3 className="text-base font-bold">
                          Add a protection plan <span className="ml-5 font-normal text-base text-gray-500 underline" >what covered</span>
                        </h3>
                        <h3 className="text-base font-normal">
                        <input type="checkbox" className="mr-2" />  <span>4 -Year plan -$30.00</span> 
                        </h3>
                      </div> 
                </div>
                <div className="flex flex-row gap-2 mt-5"></div>
              </div> */}
              {/* <div className="flex flex-col gap-2 mt-5 bg-blue-50 rounded-xl px-4">
                <div className="flex flex-row gap-2 mt-5">
                  <div> <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" transform="translate(0.329956 0.5)" fill="url(#pattern0_34_2350)" />
                        <defs>
                          <pattern id="pattern0_34_2350" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref="#image0_34_2350" transform="scale(0.01)" />
                          </pattern>
                          <image id="image0_34_2350" width="100" height="100" xlinkHref="data:image/png;base64,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" />
                        </defs>
                      </svg></div>
                      <div>
                        <h3 className="text-base font-bold">
                          Get expert help <span className="ml-5 font-normal text-base text-gray-500 underline" >what covered</span>
                        </h3>
                        <h3 className="text-base font-normal">
                          <input type="checkbox" className="mr-2"/>  <span>Mounting Service (Mount not Included) - $79.00</span>
                        </h3>
                      </div> 
                </div>
                <div className="flex flex-row gap-2 mt-5"></div>
              </div> */}

<NavLink to={'/'} className="text-[#0071BC] underline flex justify-center mt-2">
Continue Shopping
</NavLink>


              <hr className="my-3" />

              <h3 className=" font-[700] text-[16px] py-4">How will you get these items:</h3>
              <div className="flex flex-row gap-2 mb-5">
              <p className="text-sm font-normal"> <span>  </span> I want shipping & delivery savings with <span className="text-blue-800 font-bold" > M Mart</span> <br/> Choose a plan at checkout. </p> 
              </div>

              <div className="flex justify-between gap-3">

                <div className=" w-full border-[2px] justify-center rounded-lg px-4 py-3 flex flex-column">
                  <span className="text-center items-center">
                    <span className="flex justify-center">
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" transform="translate(0.329956 0.5)" fill="url(#pattern0_34_2350)" />
                        <defs>
                          <pattern id="pattern0_34_2350" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref="#image0_34_2350" transform="scale(0.01)" />
                          </pattern>
                          <image id="image0_34_2350" width="100" height="100" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA5ASURBVHgB7Z19cBTlHce/u3eEQALJVeUdCcRCrIEkxDoFRgjgC6gNiCNq8QUBBewfAhZrxwqB2jcVA+0MArXyougoRQnqVMWBBEfBFkhCCqKCScAC0dhLIAl5u93+fs/eXXLJXe4lu3eXsJ+ZzeX25W7v+e7v7dlndyVEOYV2NdGCxiwJ6jAoGA5ZGiYBSYCaqAKJ0KbWVDmnMvFOQTFklNL6xc2ILcqwSVWIYiREGYX2S0lWSDNUSOky1CxVNL5+0A8uo88ukiDtagKKM2wxRYgiokIQEiHLqkgzJRkz9BbAH5KwJClfhbJ1tK1XPiJMxARhV2RF4+PkSmbS23REAdQY5NrkVU1wFGTYepUhAoRdkEJ7TbpFsSyRZGkG2vv/qIFc2pYmKKvCLUzYBHHGhs30bxa6EOEWxnBBtCypYSV90RJ0YcIljKGClNjrKUYgB1HsmoLBFWNSbTFbYRCGCNJV3VMQ7GuGOs8Ia5GhM2wVJEYhuq8YzGT6jUeKf6jX3Q3rZiHdJVYEC/3e3FRb7DLohC6CsIvqAfkdFWpU1BMRoJRc2BQ9XFinBdHEkPaFu8KOQnQRpVOCcJFnhXUfukkWpQN2CfKU1E70j4UsiCmGTzolSkiCmGL4JWRRghbEWWNwWmuK0TF2iiljg40pQdUhrgAOU4xAsNGBu5fbLJiNghLEzKaCZjiVA29zjRboBgELctRen2uKETxUm2X0QMOKQNcPSBDuDrncKnA9oQN5SaDdLH6DuhnEdSOgIO/XQpy9tqYYnYeD/Cv+VupQkKOVl+aie/fahpssf67Lp8sy+6gMg1xXzxG+xof5tBCLghxTDEOwdZR1ebUQZyAvhYlRqBTgR3gL8F4thK0DJkYi+Qrw7SzEtI6wQVYij207lLWdhZjWETYkq6I81G5m6zcdWcfo1d+iO7J4Ul88RlOEaJdxeViIxWHWHGHGJiuedYmHILJFWgmTsGKRpezW792ClNgvZZl1R/ihNk/ntne9dwuiKpgLk0ggQRFXAgjcgsiyNAlRQnrCSeSkbENS7/O4HOALlVz/W/lPob0xXYWShCghd8xLyLqyGMPiKvDw4eUIB011taitOAtHYwM6Q49ecYgfPJTisTXgbThUcIbLlbvYyuJwpMMSPZcbVjXGI9zYT55wi+GgOrq65xXBbI4YRz3im6rRePECFRhW9Bk0NKjtZUXiK8nWCkEkizxD6BQlVDdpgpTX9kc4cDQ0eFhGZe/BqIgbhmCJa6xCctVR1FWcC1YQSZKlMfyPJgjU9HDLwXFic+bzWHtyFraevtVjWVmdJkRVU3tLefyatzH36g9x58FVtN4AGMHZb06i6LsvEQoxQ4ChtliylGrE9EkIeDu+4phfrYV2e2Ik0t2VKa+SKKewhUTJuqoYq7540N3ALkFK61oshAM8C8ixRWx/7auGxZfjBw9gx+79CAX7hDFYNi8bDeS6ghFEiyNqInm72IiMWF9aslh03Mwc+Ckd8R+Jhs4hUdhadp2bABwGCirTxLpsFTkpW5HYo1a8z6f5607eiWjkYNFX4pUthGwlmE0RY2mcJCtKZC4hYGtgtzP8w9ewtfwWsoAK5NBRz7Cr2kLC8GtijxqsHb0erB5bke29XZj8yRoUVV+DaKS2th6nTleI4K44moPatrlJHc4xJAkRhIWZe+RJ5Jx40OtyFiVj7waxnreYEm1wLC49cx7JV/dHM6XSQbgtKkcwzCrLchqigI4CdLRagy8qKqvFa1NdXXBxREKS7tcYhgK7pZXXbqOCcL3X5e/8bKVY3lUq94oftN70prqaYDaj3JcshO+sE6kKhAM5B2wO7Iw3S2CxOBvjdbg7ZcvpWzwysmjkmqQhsNkSccnhCGo70iJRViI0CI6tYd+NT7jF4EbmWMGwUIVTFopXVwxZR/UKwxlZ6a33Y0ny2zCKflcG7mbaItFh/sRj9+P6zAzRHRMMfLsptpCICFLt7B5hq3j48K88rIMtgifNRaUJUZaUPCbSYa5FjHZdN09Iw/iMUaipq3fPq7lUj5ITp5G353NySdUwiMTAe8B0hrOqoupkreZog6vBXXWHC64/2FpYrPxK43KR4i/LcZSm1rBAM2++QUynKIvK2/MvEqi8Q3FC6aiMmCCMNzEYlxDeLIGtRU8x8nZ/jOM7DuPpube757EYr72rVequ+Nr/igQkD9V6DpKHDhDVuGvdjz8txoHCr1DbyqJCJaKC+GJYnCZEQkxwPjgUzp6tgFL5jce8WTfdgFvGj/GYF9871uv2Y0YNExOzh4T5vCi0PjAXVjoCqqQoG91e8H2aCOjVjXGIBHHU+HE+BOgIjj089Q89KaiyUiFSpUaZIBxffFXuXYFjx75AiFSxy4rqu3R2Rez2kJu0TFYhlcEkaqDeXkc5LltUj5eIo6CYXVZZIOtaDm1Gd0PoUH0GdU0NePGV3e2Wx/eKpao9EaMpixpBKa9k7LADlXpNyqySqpYFsrZUfgDdDVf71tH08adH2y1vbTgDKHOakz0RU8enGSaMLKvFEp/CtaKX3d/KGWm34XKARaBucPerC0nVBBxIBeJSKgpdtYc/+mfcEOiQILUZPX8kZ9hsLfdJNxjueNMmRCUsgoPqAEXSxGi9v/ye55+lrpKnnnsV2/MCO+euNgd21pC+u4xHwQvp6DRugSxLSR1tcP1PxyAQzv73PFW/33nM4/Zf+shduPuOiUiIj8OZ89/j72/8Ezve2x9Fg480MZiEvnF49J7pmH3bjWJ///N1Gd58f7+YWBjuVN++e78oAG+a0HE3jqpqk9+DUIUYvSFWK/6hbgmdOcyFDmx4aTs2btjuMS93xSIhRlveeq8Ay1ZvRDSgOC2ALWLPtj8g9ceeLokPnDUv78QLNDEWisB9qJr/68oFJEz7unrj63tQSz3EPRN/BNlqxerfLe3o61XJIs9N7RuzTbMQWdpFB4cugrTl7tsnusUQ1kCHi+Q8XGbfMUlYyYEjvivbvn3jMXLUCK/LLl6sRc1F3/1dFy/WiHV8oaot9umKF4/cO80tRuv95cVPzJ+Fz44cp+kLsT53z7/4yrv40/IH2n4yPqM+re+cp3L5N/ijyQGRVQhBeExpib2+DAYMeJj98xbLyP3bThKgAPPvm44F907XlpMovgRJSRmBNbnPYNAg/Ucwshh33Paw271y4/NxMnv6je73L27aiY8KDiFn2QMYl/kTIcytk67XBHF+Tgn19t6+4Fkvn9/ioyZPGYcO90XED+1aQ/c5dUVR8mAwx74qx5lzlTjW6lzDkIFXel03JSUZm17+syFitKXFTiQk9HF2aJJgOylmHD95Gh/tP+xeIyGut2tVv7DAgwcPwMJF93W4ngwp3/W/Ox+joL6LXh5HJxk0uJ9IAL48cUq4izNnKzFurLaMj7TrRg4TbszFsa81cfpQQ4wiERh2UcuXPwqjGUnfN4gajD3X8a9PoaaG9vfc9xg68CphDW9u+C3+8f4nmH/PNLE+W9VnTmtO6BOPlJEjfHyypP2eUcn4xZxs8X8H0Kcq21q2bAW5Lb7rjy4D555/bhNe374L15E//uC1P3rNMqov1GHaA78RjbBw0RwsWjwHkYAbev6jT+Hfh0owfuy12Ln+Ga8GcJrc212//D2+pSzx2ZxlyM6+CZ2FjoXSMbZYt7Kew4AUVTe3Ned+7RoUtoBlqzdQ49dqKSC0NJDfL3hyjRCD3VL2jM7/uFBha1i8UDsY2AI4m2KRWvZXFWLM+3Wuc38H6CIGf7RskXM89qX1G67aLYgtpZxCl/Mj28lCXiBLYYaQG5g2KRN9Ka+/QK7hLfLPFy7WCcvhwD158jhEmvWUrr+0UUvZ2W1Nn5iJPlw3kQgffHLIub8SdrzxF+GOdKDdLTbaWSbVJGupJul0LHHBoryxPU+cKlXbVIGcDuasXhoVYrhgUTZset0jJWb4wGHLWLfmab3E4GeSbE619ZznOa8NfHmbFUohdITFOHToKPL3HRSBfuDAfhTAR5DZ3+wv4EUE3t+9+w6ImFJTU0dC9ENmZiqmTh6v5/56vQGN1+SNgvteepkME8PwZh2M17G9/LASmBiJ2gRltbcFXgURZqQoa2FiBCo/z8rXzTB9jn5vlhtWUVjze57EJDi4m8SXdTA+BeHzJLSxzw1NQkLUHR3dKtZvj4wZ4HVl32hb7JSOVvB7wQ4HeNN1dR5Vu5Gy32TJryBsXqbr6jQqNXRAD6UM6JK2NFvsWjPrChku+del2mLXBbJywMMNnKNTOJ5kwCRgSI1vqDc34L6WgC/65KyLfOAsVTx+1CQQuK0cUKcGs01IjzyyAEeouLHBxCfUef8/B5Bp6COPGP4CBxxT6AvNzMsHmhiOqaE807BTj82zwLLXtBRPWsSID+mxeSHfOIC/ULMUs0Zx0VkxGF0evWqBRJaC4biMcQbwTj96tdO31tBiijrlMs6+eKBooUOnhxPrcq8T3hExckIrHqNpuK7RiKKvGTG6iMHoPg692F6/hD50BU3dOthz7OTukEAr8EAx5MIA5039+fkYWUZ9RwRhq8jnjkK9rKI1hjbWUTs/VExa0V0CvlFW0RrDj16RhSlYKcnSQ+i61uKMFT1X+XqYl16ErYG6qDCGuidvhL1h2ggTkX3wgypuN6JgqyTLW0N9UH2oRKwxnJ2UWc4Yk4TIC8OjQYpUKHnNiF1ntGvyRVQcneLZJQoegixNklouGjJ631z1UhkU5EFW80bbeuUjwkSdL3d2WqbT0ZrNDzuRPK/qCnV/WxerdEpaypdktahZUXeHKzYEStQHV3H7bdSnk/WkoZnEkSEue2Wh+H6RbW8t5bzdFLsb7XJvBeWwolRVHOUO9C6IlCsKlP8DhKuoMktmniYAAAAASUVORK5CYII=" />
                        </defs>
                      </svg>
                    </span>
                    <span className="text-center">
                      Door step <br /> delivery<br />
                    </span>

                  </span> 
  

                </div>

                  

                <div className=" w-full border-[2px] justify-center rounded-lg px-4 py-3 flex flex-column">
                  <span className="text-center items-center">
                    <span className="flex justify-center">
                      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" transform="translate(-0.0100098 0.5)" fill="url(#pattern0_34_2365)" />
                        <defs>
                          <pattern id="pattern0_34_2365" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref="#image0_34_2365" transform="scale(0.01)" />
                          </pattern>
                          <image id="image0_34_2365" width="100" height="100" xlinkHref="data:image/png;base64,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" />
                        </defs>
                      </svg>

                    </span>
                    <span className="text-center">
                      Pickup at<br /> store <br />
                    </span>

                  </span>

                </div>



                <div className=" w-full border-[2px] justify-center rounded-lg px-4 py-3 flex flex-column">
                  <span className="text-center items-center">
                    <span className="flex justify-center">
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" transform="translate(0.670166 0.5)" fill="url(#pattern0_34_2379)" />
                        <defs>
                          <pattern id="pattern0_34_2379" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlinkHref="#image0_34_2379" transform="scale(0.01)" />
                          </pattern>
                          <image id="image0_34_2379" width="100" height="100" xlinkHref="data:image/png;base64,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" />
                        </defs>
                      </svg>

                    </span>
                    <span className="text-center">
                    Express Delivery <br />Available
                    </span>

                  </span>

                </div>

              </div>



            </div>

          </div>





        </div>

      </div>




      <div className="p-4">

        <span className="text-[20px] font-bold ">Similar Products</span>

        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1 pt-5'>
          {otherData?.data?.map(
            (data, index) => (

              // <div>
              <Link to={`/view-product/${(data?.id)}`} className=" md:w-full hover:bg-[#f1f6f9] border border-[#E6F1FC] rounded-lg p-2 cursor-pointer">
                <p className="mb-2 tracking-tight m-2 p-2 bg-[#F4FBFF] h-44" style={{ fontSize: '16px', color: '#595959', backgroundImage: `url(${data?.product_image_1})`, backgroundRepeat: "no-repeat", backgroundSize: 'cover', backgroundPosition: 'center center' }}>{data?.link_info?.message}</p>
                <div className="pt-2">
                  {data?.is_under_deal ? (
                    <div className="flex flex-col">
                    <span className="line-through mr-2 text-gray-500">
        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(data?.original_price)}
      </span>
      <h3 className='text-[16px] font-semibold'>NGN{(data?.discounted_price)}</h3>
                      </div>
                  ) : (

                    <h3 className='text-[16px] font-semibold'>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(data?.product_price)} </h3>
                  )}
                  <h5 className="text-[14px] tracking-tight text-gray-900 ">{data?.product_name}</h5>
                </div>

                {/* <div>
                  <span className='rounded-[2px] text-[11px] text-[#004F9A] bg-[#E6F1FC] px-1 py-1.5'>Same Day Delivery</span>
                </div> */}

              </Link>
              // </div>

            )
          )}
        </div>
        </div>








      <section>
        <Modal
          visible={visible}
          width="340"
          height="550"
          effect="fadeInUp"
          onClickAway={() => setVisible(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>
            <span className="flex justify-end pr-2 pt-2">
              <p className="cursor-pointer font-bold" onClick={(e) => setVisible(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
            </span>
            <div className=" bg-[#fff]  items-center rounded-lg p-1 px-4">

              <div className="">

                <span className="flex justify-around">
                  {/* <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1> */}

                </span>

                <label
                  className="flex justify-start  mb-2 pt-1 text-md font-bold text-black"
                >
                  You are about to pay for {value?.product_name}
                </label>
                {/* <label
                  style={{ fontSize: '14px' }}
                  className="flex justify-start mb-2 pt-2 text-xs font-medium text-gray-600"
                >
                  You are about to delete the Product you created.


                </label> */}




                <form onSubmit={null} className="pb-4 rounded-lg">

                  <label class="block mb-2 mt-3 text-sm  text-gray-900 dark:text-gray-600">Full Name</label>
                  <input required type="text" name="full_name" onChange={(e) => setFullName(e.target.value)} class="bg-[#F4FBFF] border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="Your Full Name" />

                  <label class="block mb-2 mt-2 text-sm  text-gray-900 dark:text-gray-600">Email</label>
                  <input required type="email" name="email" onChange={(e) => setEmail(e.target.value)} class="bg-[#F4FBFF] border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="Your Email" />


                  <label class="block mb-2 mt-2 text-sm  text-gray-900 dark:text-gray-600">Quantity</label>
                  <input required type="number" name="productQty" onChange={(e) => setProductQty(e.target.value)} class="bg-[#F4FBFF] border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="Paying for how many?" />

                  <label class="block mb-2 mt-2 text-sm  text-gray-900 dark:text-gray-600">Phone Number</label>
                  <PhoneInput
                    style={{ backgroundColor: '#F4FBFF' }}
                    disabled={false}
                    name="phone"
                    required
                    // containerClass={"shadow-sm bg-gray-100 block border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 "}
                    countryCode={'ng'}
                    onChange={setPhoneNumber}
                    placeholder={'Enter Mobile Number'}
                  />

                  <span className=" text-red-500 text-[10px]">{phoneNumber?.message}</span>

                  {/* <input required type="text"  id="customer_full_name" onChange={(e)=>setPhoneNumber(e.target.value)} class="bg-[#F4FBFF] border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="Your phone number" /> */}



                  <span className="flex justify-center pt-4">
                    <button
                      type="submit"
                      style={{ backgroundColor: '#0071BC', borderRadius: '50px' }}
                      className=" text-white hover:bg-[#0071BC] focus:ring-4 focus:outline-none focus:ring-[#0071BC] font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Proceed to payment
                    </button>
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setVisible(false)}
                      style={{ borderRadius: '50px' }}
                      className=" text-black bg-gray-300 hover:bg-gray-500 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Cancel
                    </button>
                  </span>

                </form>



              </div>

            </div>

          </div>
        </Modal>
      </section>




      <Footer />




      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  );
}
